import { render, staticRenderFns } from "./SolicitacoesTreinamentoFormulario.vue?vue&type=template&id=33666f89"
import script from "./SolicitacoesTreinamentoFormulario.vue?vue&type=script&lang=js"
export * from "./SolicitacoesTreinamentoFormulario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports